import axios from 'axios'
import HmacSHA256 from 'crypto-js/hmac-sha256'
import AES from 'crypto-js/aes'
import encBase64 from 'crypto-js/enc-base64'

const API_URL = process.env.VUE_APP_API_URL

const auth = {
  login: async (user, appId) => {
    const geoIp = await getGeoIp();
    const challengeResult = await generateChallenge(user.username,geoIp);

    if (challengeResult.status !== 200) {
      return Promise.reject(challengeResult)
    }

    let hashedRequestPassword = hashSHA256(user.password);
    let mixedChallenge = hashSHA256(challengeResult.data.msgContent.generateLoginChallenge + hashedRequestPassword);
    let requestChallenge = hashSHA256(mixedChallenge);

    return new Promise((resolve, reject) => {
      compareChallenge(user, requestChallenge, appId, geoIp)
        .then((resp) => {
          let encryptedToken = encryptToken(resp.data.msgContent.token)
          let returnedData = {token: encryptedToken.toString(), serviceUrl: resp.data.msgContent.serviceUrl, changePassLink: resp.data.msgContent.changePassLink || ''}
          resolve(returnedData)
        })
        .catch(err => {
          console.error(err.response)
          reject(err.response)
        })
    });
  },
  requestResetPassword: (username) => {
    let payload = [{
      userName: username
    }]
    return axios.post(`${API_URL}/requestForgotPassword`, payload)
  },
  resetPassword: (objModel, token) => {
    let hashedUsername = hashSHA256(objModel.username);
    let mixedChallenge = hashSHA256(token + hashedUsername);
    let requestChallenge = hashSHA256(mixedChallenge);
    let payload = [{
      userName: objModel.username,
      requestFPChallenge: requestChallenge,
      hashedNewPass: hashSHA256(objModel.newPass)
    }]
    return axios.post(`${API_URL}/resetForgotPassword`, payload)
  },
  changePassword: (objModel, token, changeInitRegPass) => {
    let payload = [{
      hashedOldPass: hashSHA256(objModel.oldPass),
      hashedNewPass: hashSHA256(objModel.newPass)
    }]

    if (changeInitRegPass) {
      payload[0]['changeInitRegPass'] = 1
    }
    return axios.post(`${API_URL}/changePassword`, payload, { headers: { authorization: token } })
  },
  register: (userModel) => {
    let payload = [{
      fullName: userModel.fullName,
      userName: userModel.userName
    }]
    return axios.post(`${API_URL}/registerua_ext`, payload)
  }
}

async function getGeoIp() {
  try {
    let postData = await axios.get('https://ipapi.co/json').then((resp) => {
      let geoLoc = {
        ip: resp.data.ip,
        latitude: resp.data.latitude,
        longitude: resp.data.longitude,
        country_code: resp.data.country,
        region_code: resp.data.region_code,
        city: resp.data.city
      }
      return geoLoc
    })
    return postData;
  } catch (e) {
    return e.response
  }
}

async function generateChallenge (username, geoLocation) {
  try {
    let payload = [{
      userName: username,
      sourceGeoLoc: {
        ip: geoLocation.ip,
        latitude: geoLocation.latitude,
        longitude: geoLocation.longitude,
        countryCode: geoLocation.country_code,
        regionCode: geoLocation.region_code,
        city: geoLocation.city
      }
    }];
    let postData = await axios.post(`${API_URL}/generateLoginChallenge`, payload).then(resp => { return resp }, err => { return err.response });

    return postData;
  } catch(e) {
    throw e
  }
}

function compareChallenge(user, requestChallenge, appId, geoLocation) {
  try {
    let payload = [{
      userName: user.username,
      requestLoginChallenge: requestChallenge,
      serviceCode: appId,
      sourceGeoLoc: {
        ip: geoLocation.ip,
        latitude: geoLocation.latitude,
        longitude: geoLocation.longitude,
        countryCode: geoLocation.country_code,
        regionCode: geoLocation.region_code,
        city: geoLocation.city
      }
    }]

    return axios.post(`${API_URL}/compareLoginChallenge`, payload);
  } catch (e) {
    console.error(e)
  }
}

function hashSHA256(requestString) {
  let hash = HmacSHA256(requestString, 'Th15_1s_4_53cr3t_5tr1ng');
  let hashInBase64 = encBase64.stringify(hash);
  return hashInBase64;
}

function encryptToken(token) {
  let encryptedToken = AES.encrypt(token, process.env.VUE_APP_PASSPHRASE);
  return encryptedToken;
}

export default auth
